"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Api_1 = __importDefault(require("./Api"));
class User extends Api_1.default {
    /**
     * @constructor
     */
    constructor(props) {
        super(props);
    }
    /**
     * Deletes the property for the active user with the given name. The property is specific to the auth client used.
     * @param name
     * @returns
     */
    deleteProperty(name) {
        const requestObj = {
            method: 'delete',
            url: `/user/property/${name}`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Get's the setting for the given client type and notification type.
     * @param client_type
     * @param notification_type
     * @returns
     */
    getNotificationSetting(client_type, notification_type) {
        const requestObj = {
            method: 'get',
            url: `/user/setting/${client_type}/${notification_type}`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Get's the setting for the given client type
     * @param client_type
     * @param notification_type
     * @returns
     */
    getNotificationSettings(client_type, notification_type) {
        const requestObj = {
            method: 'get',
            url: `/user/setting/${client_type}`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Returns the field of the profile for the given key from the active user.
     * @param key
     * @returns
     */
    getProfileField(key) {
        const requestObj = {
            method: 'get',
            url: `/user/profile/${key}`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Gets the active user.
     * @param key
     * @returns
     */
    get() {
        const requestObj = {
            method: 'get',
            url: `/user`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Returns the value of the property for the active user with the given name. The property is specific to the auth client used.
     * @param name
     * @returns
     */
    getProperty(name) {
        const requestObj = {
            method: 'get',
            url: `/user/property/${name}`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Returns the current status for the user. This includes the user data, profile data and notification data.
     * @returns
     */
    getStatus() {
        const requestObj = {
            method: 'get',
            url: `/user/status`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Sets the values of one or more properties for the active user. The properties are specific to the auth client used.
     * @param attributes
     * @returns
     */
    setProperties(attributes) {
        const requestObj = {
            method: 'put',
            url: `/user/property/`,
            data: attributes,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Sets the value of the property for the active user with the given name. The property is specific to the auth client used.
     * @param name
     * @param attributes
     * @returns
     */
    setProperty(name, attributes) {
        const requestObj = {
            method: 'put',
            url: `/user/property/${name}`,
            data: attributes,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Updates the setting for the given client type and notification type.
     * @param client_type
     * @param notification_type
     * @param attributes
     * @returns
     */
    updateNotificationSetting(client_type, notification_type, attributes) {
        const requestObj = {
            method: 'put',
            url: `/user/setting/${client_type}/${notification_type}`,
            data: attributes,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Updates the setting for the given client type
     * @param client_type
     * @param attributes
     * @returns
     */
    updateNotificationSettings(client_type, attributes) {
        const requestObj = {
            method: 'put',
            url: `/user/setting/${client_type}/`,
            data: attributes,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Updates the fields of an existing profile. Fields not specified will not be updated. To delete a field set the value of the field to null.
     * @param attributes
     * @returns
     */
    updateProfile(attributes) {
        const requestObj = {
            method: 'put',
            url: `/user/profile/`,
            data: attributes,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Updates the specific field on the user
     * @param key
     * @param attributes
     * @returns
     */
    updateProfileField(key, attributes) {
        const requestObj = {
            method: 'put',
            url: `/user/profile/${key}`,
            data: attributes,
        };
        return this._httpRequest(requestObj);
    }
}
exports.default = User;
